import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Input, InputAdornment, Grid, LinearProgress, InputLabel } from '@mui/material';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import config from '../config.json';

export default function ForgotPassword() {

  const { uidb64 } = useParams();
  const { token } = useParams();
  const [passwordShown, setPasswordShown] = useState(false);
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };
  const [isLoading, setisLoading] = useState(false)
  const initialFormData = Object.freeze({
    password: '',
    confirm_password: '',
  });

  const iformErrors = {
    password: '',
    confirm_password: '',
  }

  const [formData, updateFormData] = useState(initialFormData);
  const [formErrors, updateFormErrors] = useState(iformErrors);

  const handleChange = (e) => {

    console.log(formData)
    const { name, value } = e.target
    updateFormData({
      ...formData,
      // Trimming any whitespace
      [e.target.name]: e.target.value.trim(),
    });


    let formErr = formErrors;
    switch (name) {

      case 'password':
        formErr.password = (value.length < 6 && value.length > 0) ? "Minimum 6 characters" : "";
        break;
      case 'confirm_password':
        formErr.confirm_password = (value === (formData.password)) ? "" : "Both passwords don't match";
        break;
      default:
        break;

    }

    updateFormErrors(formErr)
    console.log(formErrors)

  };

  const handleSubmit = () => {
    if (!uidb64 || !token) {
      toast.error("Invalid or incomplete password reset link.")
      return
    }
    if (!formData.password) {
      updateFormErrors({
        ...formErrors,
        password: "Password is required",
      })
      return
    }
    if (formData.password.length < 6) {
      updateFormErrors({
        ...formErrors,
        password: "Minimum 6 characters",
      })
      return
    }
    if (!formData.confirm_password) {
      updateFormErrors({
        ...formErrors,
        confirm_password: "Please confirm your password",
      })
      return
    }
    if (formData.password !== formData.confirm_password) {
      updateFormErrors({
        ...formErrors,
        confirm_password: "Both passwords do not match",
      })
      return
    }
    setisLoading(true)
    fetch(process.env.REACT_APP_API_URL + `/api/password/${uidb64}/${token}/`, {
      method: 'POST',
      body: JSON.stringify({ 'password': formData.password }),
      headers: {
        "Content-Type": 'application/json'
      }
    }).then(res => res.json())
      .then(data => {
        //console.log(data)
        if (data['status'] === 'Success') {
          toast.success("Password changed succcessfully")
          setisLoading(false)
          window.location.href = '/login'

        }
      })
  }

  if (!isLoading) {
    return (
      <Grid
        container
        style={{ marginTop: 180, textAlign: "center", fontFamily: "Raleway" }}
      >
        <Grid item xs={12} style={{ marginBottom: 20, fontSize: 32 }}>
          Please enter your new password below
        </Grid>
        <Grid item md={4} />
        <Grid item xs={12} md={4} style={{ textAlign: "center" }}>
          <InputLabel style={{ textAlign: "left" }}>Password</InputLabel>
          <Input
            required
            fullWidth
            style={{ height: 40, marginBottom: 20 }}
            name="password"
            label="Password"
            type={passwordShown ? "text" : "password"}
            id="password"
            autoComplete="current-password"
            onChange={handleChange}
            endAdornment={
              <InputAdornment position="end">
                <Button
                  className="MuiButtonBase-root MuiButton-root MuiButton-text"
                  tabindex="0"
                  type="button"
                  onClick={togglePassword}
                >
                  <span className="MuiButton-label">
                    <span className="material-icons">visibility</span>
                  </span>
                  <span className="MuiTouchRipple-root"></span>
                </Button>
              </InputAdornment>
            }
          />
          {formErrors.password.length > 0 && (
            <Grid item style={{ textAlign: "center", marginTop: 16 }}>
              <span className=" ">{formErrors.password}</span>
            </Grid>
          )}
        </Grid>
        <Grid item md={12} />
        <Grid item md={4} />

        <Grid item xs={12} md={4} style={{ textAlign: "center" }}>
          <InputLabel style={{ textAlign: "left" }}>
            Confirm Password
          </InputLabel>
          <Input
            required
            fullWidth
            style={{ height: 40 }}
            name="confirm_password"
            type={passwordShown ? "text" : "password"}
            autoComplete="current-password"
            onChange={handleChange}
            endAdornment={
              <InputAdornment position="end">
                <Button
                  className="MuiButtonBase-root MuiButton-root MuiButton-text"
                  tabindex="0"
                  type="button"
                  onClick={togglePassword}
                >
                  <span className="MuiButton-label">
                    <span className="material-icons">visibility</span>
                  </span>
                  <span className="MuiTouchRipple-root"></span>
                </Button>
              </InputAdornment>
            }
          />
          {formErrors.confirm_password.length > 0 && (
            <Grid item xs={12} style={{ textAlign: "center", marginTop: 16 }}>
              <span className=" ">{formErrors.confirm_password}</span>
            </Grid>
          )}
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            onClick={handleSubmit}
            style={{
              backgroundColor:
                config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
              color:
                config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
              height: 40,
              width: 150,
              marginTop: 16,
            }}
          >
            submit
          </Button>
        </Grid>
      </Grid>
    );
  }
  else {
    return (
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <img
          alt={"logo"}
          style={{ height: 350, width: 300 }}
          src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`}
        />
        <LinearProgress />
      </div>
    );
  }



}

